import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAppSelector } from "hooks";

/**
 * Guest users may only use profile /info; redirect self-profile sub-routes (e.g. fuel report deep link).
 */
export default function GuestProfileRestrictedRedirect({
  children,
}: {
  children: ReactNode;
}) {
  const { companyId, userId } = useParams<{
    companyId: string;
    userId: string;
  }>();
  const { role, session } = useAppSelector((s) => s.authReducer);
  const isSelf = session?.id != null && String(session.id) === String(userId);
  const isGuest = role?.isUserGuest === true;
  if (isGuest && isSelf && companyId && userId) {
    return (
      <Navigate to={`/app/${companyId}/profile/${userId}/info`} replace />
    );
  }
  return <>{children}</>;
}
